module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraBoldItalic.5ee3b1a7.eot";